import React from 'react';
import { Box, Paper, Typography, IconButton, Collapse } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const congestionItems = [
    { className: 'no-congestion-seg', label: 'No Congestion' },
    { className: 'light-congestion-seg', label: 'Light Congestion' },
    { className: 'med-congestion-seg', label: 'Medium Congestion' },
    { className: 'hvy-congestion-seg', label: 'Heavy Congestion' },
    { className: 'vhvy-congestion-seg', label: 'Very Heavy Congestion' }
];

const historicalItems = [
    { className: 'hist-no-congestion-seg', label: 'No Congestion' },
    { className: 'hist-med-congestion-seg', label: 'Medium Congestion' },
    { className: 'hist-vhvy-congestion-seg', label: 'Very Heavy Congestion' },
    { className: 'no-data', label: 'Unknown' }
];

const MapLegend = ({ title, legendItems }) => {
    const [isOpen, setIsOpen] = React.useState(true);

    return (
        <Paper 
            elevation={3}
            sx={{
                padding: 1,
                minWidth: 160,
                margin: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.9)'
            }}
        >
            <Box 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                }}
                onClick={() => setIsOpen(!isOpen)}
            >
                <Typography variant="caption" sx={{ fontWeight: 600, color: '#000' }}>
                    {isOpen ? title : 'Legend'}
                </Typography>
                <IconButton 
                    size="small" 
                    aria-label={isOpen ? "Collapse legend" : "Expand legend"}
                    sx={{ padding: 0, pointerEvents: 'none', color: '#000' }}
                >
                    {isOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                </IconButton>
            </Box>
            <Collapse in={isOpen}>
                <Box sx={{ mt: 0.5 }}>
                    {legendItems.map((item, index) => (
                        <Box 
                            key={index}
                            sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                mb: 0.25 
                            }}
                        >
                            <Box 
                                className={`legend-color-bar ${item.className}`}
                                sx={{ 
                                    width: 24, 
                                    height: 12, 
                                    marginRight: 0.5,
                                    border: '1px solid #ccc',
                                    flexShrink: 0
                                }}
                            />
                            <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#000' }}>
                                {item.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Collapse>
        </Paper>
    );
};

export const CongestionLegend = () => (
    <MapLegend title="Congestion Level" legendItems={congestionItems} />
);

export const HistoricalCongestionLegend = () => (
    <MapLegend title="Historical Congestion" legendItems={historicalItems} />
);
